import { useEffect, useState } from "react";
import CalendarQuoteModal from "../../containers/Modals/CalendarQuoteModal";

import { load_users_short } from "../../actions/user_content";
import { load_actives_list } from "../../actions/management_content";

const CalendarModalHandler = ({ modalInfo, setModalInfo }) => {
  const [quoteOptions, setQuoteOptions] = useState({
    services: [],
    professionals: [],
  });
  const fetchQuoteOptions = async () => {
    const actives = await load_actives_list({ active_type: "service" });
    const professionals = await load_users_short({ profile_type: "CLI,CYG" });
    const options = {
      services: actives ? actives.service : [],
      professionals: professionals ? professionals : [],
    };
    if (options) {
      setQuoteOptions(options);
    }
  };
  useEffect(() => {
    fetchQuoteOptions();
  }, []);
  return (
    <CalendarQuoteModal
      show={modalInfo.show}
      onHide={() => {
        setModalInfo({ ...modalInfo, quoteId: null, show: false });
      }}
      quoteId={modalInfo.quoteId}
      quoteOptions={quoteOptions}
    />
  );
};

export default CalendarModalHandler;
